import { useEffect, useState } from "react";
// import { io } from "socket.io-client";
import { GetNotificationService, UpdateNotificationService } from "../services/NotificationServices";
import DashboardMenu from "./dashboard/DashboardMenu";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { NotificationCountAction } from "../redux/actions/authAction";



function Notification() {

  const [data, setdata] = useState({pagination:{total:0}});
  const navigator = useNavigate()
  const dispatch = useDispatch()

  const user = useSelector(state=>state.Auth)

  const [page,setpage] = useState(1)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  
  const [step,setstep] = useState(1)

  useEffect(() => {
    getData()
  }, [page]);


  async function getData() {
    const response = await GetNotificationService(page,search?.text,search?.from_date1,search?.to_date1,step)
    if(step == 1){
      dispatch(NotificationCountAction(response?.data?.pagination?.total))
    }
    setdata(response?.data)
  }
  
 async function openData(d){
    navigator('/dashboard/our_clients/edit',{state:d?.customer})
    const data = await UpdateNotificationService({read:true},d?._id)
    console.log("data",data)
  }

 async function setstepfun(s) {
    setstep(s)
    setpage(1)
    const response = await GetNotificationService(1,search?.text,search?.from_date1,search?.to_date1,s)
    setdata(response?.data)
 } 

 console.log("page",page)

  return (
    <div className='md:h-screen md:min-h-screen md:max-h-screen md:overflow-hidden'>

      <div className='md:flex'>
        <DashboardMenu />
        <div className='md:w-[100%] md:w-[86%] flex md:h-screen md:min-h-screen md:max-h-screen md:overflow-y-scroll relative'>
          <div className='w-[100%] px-4 pt-5 '> 
            <h6 className="font-[800] text-[14px] md:border-b pb-2">Notification List ({data?.pagination?.total})</h6>
            
            <div className="flex flex-wrap items-center md:absolute md:right-5 md:top-5" >
              <FiChevronLeft onClick={()=> page != 1 && setpage(page - 1) } size={20} className={`cursor-pointer border mr-1 ${page == 1 && 'opacity-20'} `} />
                <h6 className="text-[11px] mx-2">Current Page : {page} / Total Page : {data?.pagination?.totalPages} Limit: {data?.pagination?.limit}</h6>
              <FiChevronRight onClick={()=>page != data?.pagination?.totalPages && setpage(page + 1)} size={20} className={`cursor-pointer border ${page == data?.pagination?.totalPages && 'opacity-20'} `} />
            </div>

            <div className="flex mt-4 md:mt-0 border-b">
                <h6 onClick={()=>{setstepfun(1)}} className={`font-[600] ${step === 1 && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>UnRead</h6>
                <h6 onClick={()=>{setstepfun(2)}} className={`font-[600] ${step === 2 && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>Read</h6>
            </div>
            <div className="h-[85vh] overflow-y-scroll">
                {data?.datas?.map((d)=>(
                    <div key={d?._id} onClick={()=>openData(d)} className={`${!d?.read && 'bg-yellow-100'} cursor-pointer border border-t-0 p-2`}>
                        <h6 className="text-[12px]">Client : <span className="font-bold">{d?.customer?.name}</span></h6>
                        <h6 className="text-[12px]">{d?.message}</h6>
                    </div>    
                ))}
            </div>
           
          </div>
        </div>
      </div>      
    </div>
  )
}

export default Notification